import { backendClient } from '../lib/api/backendClient';

export type FavoritePlaylist = {
  id: string;
  spotifyPlaylistId: string;
  name?: string | null;
  uri?: string | null;
  ownerDisplayName?: string | null;
  ownerId?: string | null;
  description?: string | null;
  imageUrl?: string | null;
  savedAt?: string | null;
  lastPlayedAt?: string | null;
};

const toIsoString = (value: unknown): string | undefined => {
  if (typeof value === 'string' && value.trim()) {
    const parsed = new Date(value);
    return Number.isNaN(parsed.valueOf()) ? value.trim() : parsed.toISOString();
  }
  return undefined;
};

const normalizePlaylist = (raw: any): FavoritePlaylist => {
  const stringOrNull = (val: any) =>
    typeof val === 'string' && val.trim().length > 0 ? val.trim() : null;

  const spotifyPlaylistId =
    stringOrNull(raw?.spotifyPlaylistId) ??
    stringOrNull(raw?.spotify_playlist_id) ??
    stringOrNull(raw?.id) ??
    '';

  return {
    id: stringOrNull(raw?.id) ?? spotifyPlaylistId,
    spotifyPlaylistId,
    name: stringOrNull(raw?.name),
    uri: stringOrNull(raw?.uri),
    ownerDisplayName: stringOrNull(raw?.ownerDisplayName) ?? stringOrNull(raw?.owner_display_name),
    ownerId: stringOrNull(raw?.ownerId) ?? stringOrNull(raw?.owner_id),
    description: stringOrNull(raw?.description),
    imageUrl: stringOrNull(raw?.imageUrl) ?? stringOrNull(raw?.image_url),
    savedAt: toIsoString(raw?.savedAt ?? raw?.saved_at) ?? null,
    lastPlayedAt: toIsoString(raw?.lastPlayedAt ?? raw?.last_played_at) ?? null,
  };
};

export const favoritePlaylistsService = {
  async listFavoritePlaylists(): Promise<FavoritePlaylist[]> {
    const { data } = await backendClient.get<{ playlists?: any[] }>('/favorites/playlists');
    const playlists = Array.isArray(data?.playlists) ? data.playlists : [];
    return playlists.map(normalizePlaylist);
  },
};

export default favoritePlaylistsService;
